<template>
  <div class="is-inline-block" v-if="hasOverrideAccess">
    <span class="is-inline-block" v-if="hasOverrideAccess">
      <span :id="instanceId" :name="instanceId" class="icon has-text-centered" title="Accessories not needed" @click.stop.prevent="onEditOverrides()" v-if="isListMode">
        <i class="fal fa-cog fa-lg"/>
      </span>
      <div :id="instanceId" :name="instanceId" class="quick-action">
        <button class="button" @click.stop.prevent="onEditOverrides()" title="Accessories not needed">
          <b-icon pack="fal" icon="cog" custom-size="fa-lg"></b-icon>
        </button>
      </div>
    </span>
    <portal to="global-modal-portal" v-if="isEditOverrideActive" :order="1">
      <b-modal :active.sync="isEditOverrideActive" :width="640" scroll="keep" :has-modal-card="true" v-if="currentInventory">
        <div class="modal-card" style="width: 640px">
          <header class="modal-card-head">
            <div class="columns">
              <div class="column is-12">
                <p class="modal-card-title">Configure accessory not needed</p>
              </div>
            </div>
          </header>
          <section class="modal-card-body" style="padding:12px">
            <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
            <form class="view-container">
              <div class="columns is-multiline">
                <div class="column is-6">
                  <button-list-selector :enabled="true" label="Books" validateAs="Books Type" :required="true" v-model="selectedBooksStatus" :availableValues="availableBooksStatus"></button-list-selector>
                  <span v-show="errors.has('selectedBooksStatus')" class="help is-danger"><i v-show="errors.has('selectedBooksStatus')" class="fas fa-exclamation-triangle"></i> {{ errors.first('selectedBooksStatus') }}</span>
                  <switch-selector type="is-info" label="Books Not Needed" v-model="currentInventory.booksStatusOverride"></switch-selector>
                </div>
                <div class="column is-6">
                  <button-list-selector :enabled="true" label="Keys" validateAs="Keys Status" :required="true" v-model="selectedKeyStatus" :availableValues="availableKeyStatus"></button-list-selector>
                  <span v-show="errors.has('selectedKeyStatus')" class="help is-danger"><i v-show="errors.has('selectedKeyStatus')" class="fas fa-exclamation-triangle"></i> {{ errors.first('selectedKeyStatus') }}</span>
                  <switch-selector type="is-info" label="Key Not Needed" v-model="currentInventory.keyStatusOverride"></switch-selector>
                </div>
                <div class="column is-6">
                  <button-list-selector :enabled="true" label="Car Cover" validateAs="car Cover Status" :required="true" v-model="selectedCarCoverStatus" :availableValues="availableCarCoverStatus"></button-list-selector>
                  <span v-show="errors.has('selectedCarCoverStatus')" class="help is-danger"><i v-show="errors.has('selectedCarCoverStatus')" class="fas fa-exclamation-triangle"></i> {{ errors.first('selectedCarCoverStatus') }}</span>
                  <switch-selector type="is-info" label="Car Cover Not Needed" v-model="currentInventory.carCoverStatusOverride"></switch-selector>
                </div>
                <div class="column is-6">
                  <button-list-selector :enabled="true" label="Battery Charger" validateAs="Battery Charger Status" :required="true" v-model="selectedBatteryChargerStatus" :availableValues="availableBatteryChargerStatus"></button-list-selector>
                  <span v-show="errors.has('selectedBatteryChargerStatus')" class="help is-danger"><i v-show="errors.has('selectedBatteryChargerStatus')" class="fas fa-exclamation-triangle"></i> {{ errors.first('selectedBatteryChargerStatus') }}</span>
                  <switch-selector type="is-info" label="Battery Charger Not Needed" v-model="currentInventory.batteryChargerStatusOverride"></switch-selector>
                </div>
              </div>
            </form>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary" :class="{ 'is-loading': isSaving }"  @click="onSave()">Save</button>
            <button class="button is-danger" @click="isEditOverrideActive = false">Cancel</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>
import eventBus from '@/eventBus'
import inventoryService from '@/services/inventoryService'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import SwitchSelector from '@/components/generic/SwitchSelector'
import ButtonListSelector from '@/components/generic/ButtonListSelector'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'

import { createNamespacedHelpers } from 'vuex'
const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'CaptureAccessoryOverride',
  mixins: [validateBeforeSubmitMixin],
  components: {
    'error-display-component': ErrorDisplayComponent,
    'switch-selector': SwitchSelector,
    'button-list-selector': ButtonListSelector
  },
  props: {
    inventoryItem: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'is-width-600'
    },
    isListMode: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isEditOverrideActive: false,
      isSaving: false,
      instanceId: this.$uuid.v4(),
      serverErrors: [],
      serverErrorMessage: '',
      currentInventory: this.inventoryItem,
      selectedBooksStatus: null,
      selectedKeyStatus: null,
      selectedCarCoverStatus: null,
      selectedBatteryChargerStatus: null
    }
  },
  computed: {
    ...mapUserGetters(['currentUser', 'hasFeatureAccess']),
    ...mapConfigGetters(['definedTypes']),
    hasOverrideAccess: function () {
      return this.hasFeatureAccess('inventory.modify.set-accessory-override', false)
    },
    availableKeyStatus: function () {
      return [
        {
          id: null,
          name: 'None',
          altName: 'None',
          ico: 'fas fa-check has-text-danger'
        },
        ...this.definedTypes.keyOptions
      ]
    },
    availableBooksStatus: function () {
      return [
        ...this.definedTypes.bookTrackingOptions
      ]
    },
    availableCarCoverStatus: function () {
      return [
        ...this.definedTypes.carCoverTrackingOptions
      ]
    },
    availableBatteryChargerStatus: function () {
      return [
        ...this.definedTypes.batteryChargerTrackingOptions
      ]
    }
  },
  methods: {
    onEditOverrides: function () {
      this.isEditOverrideActive = true
    },
    onSave: function () {
      this.serverErrorMessage = ''
      this.serverErrors = []
      this.isSaving = true
      this.$validator.validateAll('accessory-event-form').then((result) => {
        if (result) {
          let accessoryOverrideModel = {
            inventoryId: this.currentInventory.id,
            booksStatusOverride: this.currentInventory.booksStatusOverride,
            keyStatusOverride: this.currentInventory.keyStatusOverride,
            carCoverStatusOverride: this.currentInventory.carCoverStatusOverride,
            batteryChargerStatusOverride: this.currentInventory.batteryChargerStatusOverride,
            keyStatus: this.selectedKeyStatus ? this.selectedKeyStatus.id : null,
            booksStatus: this.selectedBooksStatus ? this.selectedBooksStatus.id : null,
            carCoverStatus: this.selectedCarCoverStatus ? this.selectedCarCoverStatus.id : null,
            batteryChargerStatus: this.selectedBatteryChargerStatus ? this.selectedBatteryChargerStatus.id : null
          }

          inventoryService.saveAccessoryOverrides(accessoryOverrideModel).then(response => {
            this.isSaving = false
            if (response.errors) {
              this.serverErrors = response.errors
            } else {
              eventBus.$emit('quickview-refresh')
              eventBus.$emit('reload-inventory-list')
              this.isEditOverrideActive = false
            }
          }).catch((error) => {
            this.serverErrorMessage = error.message
            this.isSaving = false
          })
        }
      })
    },
    loadInventory: function () {
      if (this.currentInventory) {
        if (this.currentInventory.keyStatus) {
          if (this.currentInventory.keyStatus === 'Two') {
            this.selectedKeyStatus = this.definedTypes.keyOptions.find((x) => (x.id === 1))
          } else {
            this.selectedKeyStatus = {
              id: null,
              name: 'None',
              altName: 'None',
              ico: 'fas fa-check has-text-danger'
            }
          }
        }
        this.selectedBatteryChargerStatus = this.definedTypes.batteryChargerTrackingOptions.find((x) => (x.name === this.currentInventory.batteryChargerStatus || x.altName === this.currentInventory.batteryChargerStatus))
        this.selectedBooksStatus = this.definedTypes.bookTrackingOptions.find((x) => (x.name === this.currentInventory.booksStatus || x.altName === this.currentInventory.booksStatus))
        this.selectedCarCoverStatus = this.definedTypes.carCoverTrackingOptions.find((x) => (x.name === this.currentInventory.carCoverStatus || x.altName === this.currentInventory.carCoverStatus))
      }
    },
    onStockNoClick: function (inventory) {
      let that = this

      this.$copyText(inventory.stockNo).then(
        function (e) {
          that.$buefy.toast.open({
            duration: 2500,
            message: 'Stock No. ' + inventory.stockNo + ' copied to clipboard',
            position: 'is-top',
            type: 'is-info'
          })
        }, function (e) {
          that.$buefy.toast.open({
            duration: 2500,
            message: 'Could not copy stock no. to clipboard',
            position: 'is-top',
            type: 'is-warning'
          })
        }
      )
    }
  },
  watch: {
    inventoryItem: function (newValue) {
      if (newValue) {
        this.currentInventory = newValue
      }
    }
  },
  mounted () {
    this.loadInventory()
  }
}

</script>

<style scoped>
  .content ul{
    list-style-type: none;
    margin-top: 0
  }

  .modal-card-head, .modal-card-foot{
    padding: 20px !important
  }

  .modal-card-body {
    overflow:auto;
    height: calc(50vh - 10px);
  }
</style>
